/*=============================================== Nav ===============================================*/

import type { PageCategoryType } from "data/types"

export const navItems: string[] = ["/", "/getting-started"]

export const categoryItems: PageCategoryType[] = [
    "styles",
    "layouts",
    "components",
    "helpers",
]
